module.exports = __webpack_public_path__ + "static/circle-cropped-b5bdf50c75de3d8a323c59d433b55195.jpg";